var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memorandum"},[_c('div',{staticClass:"memorandum-box max_W clear"},[_c('schedule-calendar',{attrs:{"events":_vm.dataList,"dateItemRender":_vm.itemRender}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }